
import { GameState, GameSettings } from '../GameContextTypes';

export const updateSettings = (state: GameState, settings: GameSettings): GameState => {
  return {
    ...state,
    settings: {
      ...settings
    }
  };
};
